import React from 'react';
import {
  Box,
  Typography,
  Chip,
  Card,
  IconButton,
  CircularProgress,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import EditIcon from '@mui/icons-material/Edit';

interface SubGoal {
  Name?: string;
  description?: string;
  startDate?: string;
  endDate?: string;
}

interface GoalCardStudentProps {
  title: string;
  description: string;
  type: string;
  Id: any;
  progress?: { done: number; total: number } | null;
  assignedGoals: string;
  isOnlyFaculty?: boolean;
  isFaculty?: boolean;
  status?: any;
  startdate?: string;
  enddate?: string;
  goalType?: string;
  subgoals?: SubGoal[];
  profile?: boolean;
}

const GoalCardStudent: React.FC<GoalCardStudentProps> = ({
  Id,
  title = 'Untitled Goal',
  description = 'No description provided',
  type = 'Unknown',
  progress = { done: 0, total: 0 },
  assignedGoals = '',
  isOnlyFaculty = false,
  isFaculty = false,
  status,
  profile,
  startdate,
  enddate,
  goalType,
  subgoals = [],
}) => {
  const navigate = useNavigate();
  const goalId = Id;

  const done = progress?.done ?? 0;
  const total = progress?.total ?? 0;
  const percentage = total > 0 ? Math.round((done / total) * 100) : 0;

  const handleArrowClick = () => {
    if (assignedGoals === 'mygoals') {
      navigate(`/goals/${encodeURIComponent(goalId)}/edit`);
    } else {
      navigate(`/goals/${encodeURIComponent(goalId)}`);
    }
  };

  const handleEditClick = () => {
    // Convert subgoals to proper format if needed
    const convertedSubgoals = subgoals.map((s) => ({
      title: s.Name,
      description: s.description,
      startDate: s.startDate ? new Date(s.startDate) : null,
      endDate: s.endDate ? new Date(s.endDate) : null,
    }));
    console.log(convertedSubgoals, 'convertedSubgoals');
    navigate('/goals/add-goals', {
      state: {
        id: goalId,
        title,
        description,
        type,
        progress,
        goalType,
        startdate,
        enddate,
        subgoals: convertedSubgoals,
      },
    });
  };


  return (
    <Card
      sx={{
        p: 2,
        borderRadius: 2,
        boxShadow: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        textAlign: 'left',
        border: '0.5px solid #E9E9ED !important',
        borderShadow: 'none !important',
      }}
    >
      <Box>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography sx={{ fontSize: '18px', fontWeight: 500 }}>
            {title}
          </Typography>

          <Box display="flex" alignItems="center" gap={1}>
            {assignedGoals === 'mygoals' && (
              <IconButton size="small" onClick={handleEditClick}>
                <EditIcon fontSize="small" />
              </IconButton>
            )}
            <IconButton size="small" onClick={handleArrowClick}>
              <ArrowForwardIosRoundedIcon fontSize="small" />
            </IconButton>
          </Box>
        </Box>

        <Typography sx={{ fontSize: '14px', mt: 1, color: 'text.secondary' }}>
          {description}
        </Typography>
      </Box>

      <Box display="flex" mt={2} gap={2} alignItems="center">
        <Chip
          label={type}
          size="small"
          color="default"
          sx={{ mt: 1, backgroundColor: '#EDEEF1' }}
        />
      </Box>

      {status && (
        <Typography fontSize={'12px'} mt={2}>
          {status}
        </Typography>
      )}

      {profile && (
        <Box mt={2} display="flex" alignItems="center" gap={2}>
          <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress
              variant="determinate"
              value={percentage === 0 ? 1 : percentage}
              size={50}
              thickness={4}
              sx={{
                color: percentage === 0 ? '#d3d3d3' : '#2E4BCF',
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography variant="caption" color="text.secondary">
                {`${percentage}%`}
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
    </Card>
  );
};

export default GoalCardStudent;
